import _ from 'lodash';

export default function classnames(...args) {
  const classes = _.extend({}, ..._.map(args, a => (_.isString(a) ? { [a]: true } : a)));
  return _(classes).pickBy().keys().join(' ');
}
